<template>
  <div>
    <b-row>
      <b-col lg="6">
        <SelectWithSearch
          label="Class. trib. IS"
          v-model="classTribIS"
          :filterBy="taxFilter"
          :options="classTribISCollection"
          disabled
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Nenhum resultado encontrado </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col lg="6">
        <SelectWithSearch
          label="CST IS"
          disabled
          v-model="cstIS"
          :filterBy="taxFilter"
          :options="CSTISCollection"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Nenhum resultado encontrado </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
        </SelectWithSearch>
      </b-col>
    </b-row>
    <b-row class="mt-lg-2">
      <b-col lg="3">
        <InputMoney
          label="Base de cálculo"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS.vBCIS"
          disabled
        />
      </b-col>
      <b-col lg="3">
        <InputQuantity
          id="pIS"
          label="Alíquota"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS.pIS"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputQuantity
          id="pISEspec"
          label="Alíquota específica"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS.pISEspec"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <Label disabled>Unidade tributável</Label>
        <Input
          id="uTrib"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS.uTrib"
          :mask="[uTribMask]"
          disabled
        />
      </b-col>
    </b-row>
    <b-row class="mt-lg-2">
      <b-col lg="3">
        <InputQuantity
          id="qTrib"
          label="Qtd tributável"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS.qTrib"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS.vIS"
          disabled
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SelectWithSearch, InputMoney, InputQuantity, Label, Input } from '@/components/Form';

export default {
  name: 'IS',
  components: {
    Label,
    Input,
    InputMoney,
    InputQuantity,
    SelectWithSearch,
  },
  data() {
    return {
      uTribMask: '######',
      classTribIS: null,
      cstIS: null,
      taxFilter(option, _, search) {
        if (!search) return true;

        const searchToLower = search.toLowerCase();

        const codigoMatch = option.codigo
          ?.toString()
          .toLowerCase()
          .includes(searchToLower);
        const descricaoMatch = option.descricao
          ?.toString()
          .toLowerCase()
          .includes(searchToLower);

        return codigoMatch || descricaoMatch;
      },
    };
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
    ...mapState('ibsRegime', ['classTribISCollection', 'CSTISCollection']),
  },
  mounted() {
    const classTrib = this.classTribISCollection.find(
      (e) => e.codigo === this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime?.IS?.cClassTribIS,
    );

    const cst = this.CSTISCollection.find(
      (e) => e.codigo === this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime?.IS?.CSTIS,
    );

    if (classTrib) {
      this.classTribIS = classTrib;
    }

    if (cst) {
      this.cstIS = cst;
    }
  },
};
</script>
